import { EventObject, State } from 'xstate'

import {
  TransferBpayState,
  TransferContactState,
  TransferGeneralState,
  TransferZellerState,
} from 'pages/Transfer/Transfer.stateMachine'

const SUMMARY_STATES = [
  `${TransferGeneralState.ZellerTransfer}.${TransferZellerState.Summary}`,
  `${TransferGeneralState.ContactTransfer}.${TransferContactState.Summary}`,
  `${TransferGeneralState.ContactTransfer}.${TransferContactState.DeOutFallbackSummary}`,
  `${TransferGeneralState.BpayTransfer}.${TransferBpayState.Summary}`,
]

const SENDING_STATES = [
  `${TransferGeneralState.ZellerTransfer}.${TransferZellerState.Sending}`,
  `${TransferGeneralState.ContactTransfer}.${TransferContactState.Sending}`,
  `${TransferGeneralState.BpayTransfer}.${TransferBpayState.Sending}`,
]

export const getIsOnSummaryState = (
  state: State<
    any,
    EventObject,
    any,
    {
      value: any
      context: any
    }
  >
) => {
  return SUMMARY_STATES.some(state.matches)
}

export const getIsOnSendingState = (
  state: State<
    any,
    EventObject,
    any,
    {
      value: any
      context: any
    }
  >
) => {
  return SENDING_STATES.some(state.matches)
}
